import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "fz_cookie_consent_v1";

export function getCookieConsent() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"); }
  catch { return null; }
}

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const c = getCookieConsent();
    if (!c) {
      // Delay to avoid layout flash on first paint
      const t = setTimeout(() => setShow(true), 500);
      return () => clearTimeout(t);
    }
  }, []);

  const save = (level) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      level, // "essential" | "all"
      analytics: level === "all",
      marketing: level === "all",
      timestamp: new Date().toISOString(),
    }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:left-auto md:bottom-6 md:max-w-md z-50 zen-card p-5 shadow-2xl border-zen-primary/20"
      data-testid="cookie-banner"
      role="dialog"
      aria-labelledby="cookie-title"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-zen-primary/10 text-zen-primary flex items-center justify-center shrink-0">
          <Cookie size={18}/>
        </div>
        <div className="min-w-0 flex-1">
          <h3 id="cookie-title" className="font-heading text-lg mb-1">Cookie e privacy</h3>
          <p className="text-sm text-zen-ink2 leading-relaxed">
            Usiamo cookie tecnici essenziali per farti accedere e mantenere la sessione. Con il tuo consenso,
            possiamo attivare anche cookie analitici per capire come migliorare l&apos;app. Leggi la nostra{" "}
            <Link to="/privacy" className="text-zen-primary hover:underline">Privacy Policy</Link> e i{" "}
            <Link to="/terms" className="text-zen-primary hover:underline">Termini di Servizio</Link>.
          </p>
        </div>
        <button
          data-testid="cookie-close"
          onClick={() => save("essential")}
          className="text-zen-ink2 hover:text-zen-ink shrink-0"
          aria-label="Chiudi"
        >
          <X size={18}/>
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        <Button
          data-testid="cookie-essential"
          onClick={() => save("essential")}
          variant="outline"
          className="flex-1 rounded-full"
        >
          Solo essenziali
        </Button>
        <Button
          data-testid="cookie-accept-all"
          onClick={() => save("all")}
          className="flex-1 bg-zen-primary hover:bg-zen-primaryHover rounded-full"
        >
          Accetta tutti
        </Button>
      </div>
    </div>
  );
}
